export const getImgUrl = (pic) => {
  return require("@/assets/" + pic);
};
const reg =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

export const isValidEmail = (email) => {
  return reg.test(email);
};

export const isEmpty = (...strings) => {
  return Boolean(strings.filter((str) => str.trim() === "").length);
};
